const { createUrlPattern, isBot } = require("./datadogInitHelpers");

// Initialize the datadog RUM
export const initDataDogRUM = (datadogRum, initialState) => {
  if (initialState?.datadogRum?.applicationId) {
    const baseUrl = `https://${window.location.host}`;
    const trafficSource = initialState?.header?.userDetails?.trafficSourceInfo;
    const telemetryUrlPath = "https://telemetry.ebsco.com/";
    const rteUrlPath = createUrlPattern(baseUrl, "rte");
    const aptrinsicUrlPath = createUrlPattern(baseUrl, "gainsight/api");
    const contentUrlPaths = createUrlPattern(baseUrl, "api");
    const ddRumAnalyticsUrlPath = createUrlPattern(baseUrl, "analytics/api/v2");
    const conditionalSampleRate = isBot(navigator.userAgent);

    let frameHost;
    if (window?.location !== window?.parent?.location) {
      frameHost = window?.document?.referrer;
    }

    datadogRum.init({
      ...initialState.datadogRum,
      version: window.DD_VERSION,
      proxy: (options) =>
        `${baseUrl}/analytics${options.path}?${options.parameters}`,
      allowedTracingUrls: [baseUrl],
      sessionSampleRate: conditionalSampleRate,
      excludedActivityUrls: [
        rteUrlPath,
        aptrinsicUrlPath,
        telemetryUrlPath,
        contentUrlPaths,
        ddRumAnalyticsUrlPath
      ]
    });

    window.DD_RUM?.setGlobalContextProperty("global", {
      affiliationId:
        initialState?.header?.userDetails?.affiliationId || "unknown",
      productCode: initialState?.productInfo?.productCode || "unknown",
      applicationCode: initialState?.productInfo?.applicationCode || "unknown",
      trafficSource,
      frameHost
    });
  }
};
